import { COUNTRY_CODES } from './data';
import { getSubdivisions } from '../../functions/src/common/dailyReportArea';

export function addressSubdivisions(country: string) {
    return getSubdivisions((COUNTRY_CODES as Record<string, { iso3: string }>)[country]?.iso3 || '');
}

export function subdivisionValue(country: string, value: string) {
    const current = value.trim();
    const match = addressSubdivisions(country).find(region =>
        region.name.toLowerCase() === current.toLowerCase() || region.code.toLowerCase() === current.toLowerCase() ||
        region.code.split('-').pop()?.toLowerCase() === current.toLowerCase());
    return match?.name || current;
}
